import { useEffect, useState } from 'react';
import { lazyLoadHtmlImages } from '../utils/lazyImages';

type CommonPostMessagePropsType = {
  myChat: any;
  // chatType: any;
};

export function normalizePostMessage(message: any): string {
  if (message == null) {
    return '';
  }

  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message)) {
    return message.map((item) => normalizePostMessage(item)).join('');
  }

  if (typeof message === 'number' || typeof message === 'boolean') {
    return String(message);
  }

  if (typeof message === 'object') {
    return normalizePostMessage(
      message.chat_msg ?? message.message ?? message.text ?? ''
    );
  }

  return '';
}

function removeTags(message: any) {
  const string = normalizePostMessage(message);
  if (!string) {
    return [];
  }

  // let newstring = string
  //   ?.replace(/<[^>]*>/g, ' ')
  //   ?.replace(/\s{2,}/g, ' ')
  //   ?.trim();
  // let content = newstring?.split(/((?:#|@|https?:\/\/[^\s]+)[a-zA-Z]+)/);
  let content = string.trim().split(/((?:#|@)[A-Za-z0-9_-]+)/);
  let hashtag;

  return content?.map((word: any) => {
    if (word.startsWith('#')) {
      hashtag = word.replace('#', '');
      const encodedHashtag = encodeURIComponent(hashtag);
      return (
        `
          <a href='/disneyland/hash/${encodedHashtag}' onclick="event.stopPropagation();" style="color: blue; text-decoration: underline;">${word}</a>`
      );
    } else {
      return word;
    }
  });
}
// Photos uploaded through the post editor live under /chat_images/; stickers
// and emoji use other paths and are often placed mid-sentence.
const UPLOADED_PHOTO_SRC = /\/chat_images\//;

/**
 * Some advanced-editor posts put the uploaded photo before the caption.
 * Show the caption first, like every other post: uploaded photos that come
 * before any text move below it. Stickers, photos after text, and photo-only
 * posts are left untouched.
 */
export function moveLeadingPhotosBelowText(html: string): string {
  if (!html || typeof DOMParser === 'undefined' || !html.includes('chat_images')) {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const walker = doc.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT
  );
  const leadingPhotos: HTMLImageElement[] = [];
  let hasTextAfterPhotos = false;

  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (node.nodeType === Node.TEXT_NODE) {
      if ((node.textContent || '').trim()) {
        hasTextAfterPhotos = leadingPhotos.length > 0;
        break;
      }
      continue;
    }
    if ((node as Element).tagName === 'IMG') {
      if (!UPLOADED_PHOTO_SRC.test((node as HTMLImageElement).getAttribute('src') || '')) {
        break;
      }
      leadingPhotos.push(node as HTMLImageElement);
    }
  }

  if (!leadingPhotos.length || !hasTextAfterPhotos) {
    return html;
  }

  const photoBlock = doc.createElement('p');
  photoBlock.className = 'mw-post-photos';
  leadingPhotos.forEach((img) => {
    const parent = img.parentElement;
    photoBlock.appendChild(img);
    if (parent && parent !== doc.body && !parent.textContent?.trim() && !parent.querySelector('img')) {
      parent.remove();
    }
  });
  doc.body.appendChild(photoBlock);
  return doc.body.innerHTML;
}

export const CommonPostMessage: React.FC<CommonPostMessagePropsType> = ({
  myChat
  // chatType
}) => {
  const [newChat, setNewChat] = useState(() =>
    lazyLoadHtmlImages(moveLeadingPhotosBelowText(normalizePostMessage(myChat)))
  );

  useEffect(() => {
    setNewChat(lazyLoadHtmlImages(moveLeadingPhotosBelowText(removeTags(myChat).join(''))));
  }, [myChat]);

  return (
    <div
      className='commonPostDetailMsg'
      dangerouslySetInnerHTML={{ __html: newChat }}
    />
  );
};
